import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import AppText from "../../../../components/Core/AppText/AppText";
import { ICON_TYPE } from "../../../../configs/constants/IconsTypes";
import { RecruitmentHistoryType } from "../../../../configs/constants/RecruitmentHistoryType";
import Flex from "../../../../components/Layout/Flex";
import { getHistoryMetadataString } from "../../../../utils/recruitment.utils";
import { History } from "../../../../models/RecruitmentHistory";
import MessageBox from "../../../../components/Shared/MessageBox/MessageBox";
import { appTheme } from "../../../../theme/Theme";

interface ThirdLevelProps {
	actionSubItem: History;
}

const ThirdLevel: React.FC<ThirdLevelProps> = ({
	actionSubItem: { data, date, id, type, user },
}) => {
	const { t } = useTranslation();

	let icon!: ICON_TYPE;

	switch (type) {
		case RecruitmentHistoryType.NOTE_CHANGED:
			icon = ICON_TYPE.NOTES_ICON;
			break;

		case RecruitmentHistoryType.MESSAGE_SENT:
			icon = ICON_TYPE.MESSAGE_ICON;
			break;

		default:
			icon = ICON_TYPE.GREEN_CHECK;
	}

	return (
		<Flex alignItems="flex-start" margin="0 0 0 65px" className="actions_sub-wrapper" key={id}>
			<SubActionImage src={icon} alt="sub-action-icon" />
			<Flex direction="column" className="actions_sub-wrapper-child">
				<AppText size="m" color="black">
					{t(type as any)}
					{type === RecruitmentHistoryType.MESSAGE_SENT && <>&nbsp;"{data?.message}"</>}
				</AppText>
				<AppText size="xs" color="grayTextLight" margin="4px 0 0 0">
					{getHistoryMetadataString(date, user?.firstName, user?.lastName)};
				</AppText>
				{type === RecruitmentHistoryType.NOTE_CHANGED && (
					<MessageBox message={data?.notes || ""} width="294px" margin="6px 0 0 0" />
				)}
			</Flex>
		</Flex>
	);
};

export default ThirdLevel;

const SubActionImage = styled.img`
	margin: 3px 15.4px 0 0;
	background: ${appTheme.colors.COLOR_LIGHT_GRAY};
`;
